var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3457 13.29V13.3877H11.0059V13.29C11.0303 11.9635 11.4128 11.3776 12.3893 10.7835C13.4229 10.1488 14.0495 9.27799 14.0495 7.96777C14.0495 6.1123 12.6335 4.84277 10.5176 4.84277C8.58073 4.84277 7.01823 5.97396 6.95312 8.04915H8.71094C8.78418 6.84473 9.63867 6.30762 10.5176 6.30762C11.4941 6.30762 12.2754 6.95052 12.2754 7.96777C12.2754 8.82227 11.7546 9.42448 11.071 9.83952C9.99674 10.5068 9.37012 11.1579 9.3457 13.29ZM9.08529 15.7477C9.07715 16.3825 9.60612 16.8952 10.2409 16.9033C10.8675 16.8952 11.3883 16.3825 11.3965 15.7477C11.3883 15.113 10.8675 14.5921 10.2409 14.5921C9.60612 14.5921 9.07715 15.113 9.08529 15.7477Z",
    fill: "#55595F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.08203,
    y: 1.45605,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#55595F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.db29c35dacb87e2280f54dc411624cbf.svg";
export { ForwardRef as ReactComponent };